import { render, staticRenderFns } from "./FormattedSolVar.vue?vue&type=template&id=38ace8d7&scoped=true&"
import script from "./FormattedSolVar.vue?vue&type=script&lang=js&"
export * from "./FormattedSolVar.vue?vue&type=script&lang=js&"
import style0 from "./FormattedSolVar.vue?vue&type=style&index=0&id=38ace8d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ace8d7",
  null
  
)

export default component.exports